import { Button, Checkbox, Form, Input, Modal, Select, Space, Upload } from "antd";
import { CloseOutlined, SaveOutlined, UploadOutlined } from "@ant-design/icons";

const SettingsBanner = ({
  isMobile,
  open,
  title,
  loading,
  onSave,
  onClose,
  form,
  programs,
  uploadFileList,
  setUploadFileList,
  editingBanner,
}) => {
  const formView = (
    <Form form={form} layout="vertical">
      <Form.Item name="name" label="Название" rules={[{ required: true, message: "Введите название" }]}>
        <Input />
      </Form.Item>
      <Form.Item name="progId" label="Программа" rules={[{ required: true, message: "Выберите программу" }]}>
        <Select options={programs.map((p) => ({ label: p.name, value: p.id }))} placeholder="Выберите программу" />
      </Form.Item>
      <Form.Item name="isAct" valuePropName="checked">
        <Checkbox>Активен</Checkbox>
      </Form.Item>
      <Form.Item name="url" label="URL">
        <Input />
      </Form.Item>
      <Form.Item name="komment" label="Комментарий">
        <Input.TextArea rows={3} />
      </Form.Item>
      <Form.Item label="Картинка">
        <Upload
          beforeUpload={() => false}
          maxCount={1}
          fileList={uploadFileList}
          onChange={({ fileList }) => setUploadFileList(fileList)}
        >
          <Button icon={<UploadOutlined />}>Выбрать файл</Button>
        </Upload>
        {editingBanner?.fileName ? (
          <div className="settings-banners-current-file">Текущий файл: {editingBanner.fileName}</div>
        ) : null}
      </Form.Item>
    </Form>
  );

  if (isMobile) {
    return open ? (
      <div
        className="misoft-modal-overlay company-base-overlay--mobile settings-banners-edit-overlay"
        onClick={(e) => e.target === e.currentTarget && onClose()}
      >
        <div
          className="misoft-modal-content company-base-sheet--mobile settings-banners-edit-panel"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="company-base-sheet-header">
            <span className="company-base-sheet-title">{title}</span>
            <Space size="small" className="company-base-sheet-actions">
              <Button
                type="primary"
                icon={<SaveOutlined />}
                onClick={onSave}
                loading={loading}
                aria-label="Сохранить"
                className="company-base-header-icon-btn"
              />
              <Button
                type="default"
                icon={<CloseOutlined />}
                onClick={onClose}
                aria-label="Закрыть"
                className="company-base-header-icon-btn"
              />
            </Space>
          </div>
          <div className="company-base-sheet-body">{formView}</div>
        </div>
      </div>
    ) : null;
  }

  return (
    <Modal
      title={title}
      open={open}
      onOk={onSave}
      onCancel={onClose}
      okText="Сохранить"
      cancelText="Отмена"
      destroyOnClose
    >
      {formView}
    </Modal>
  );
};

export default SettingsBanner;
